// Library Imports
import axios from 'axios';

// Set up axios defaults
axios.defaults.baseURL = 'https://www.commentoid.com';
axios.defaults.withCredentials = false;

export async function requestDemo (payload) {
   var f = await axios.post('/requestdemo', payload);
   return f;
}

export async function getTrendingFeed (payload) {
   var f = await axios.get('/api/feed/trending', {
      params: payload
   });
   return f;
}

export async function getReplaysFeed (payload) {
   var f = await axios.get('/api/feed/replays', {
      params: payload
   });
   return f;
}

export async function getTopicEntries (payload) {
   var f = await axios.get('/api/topic', {
      params: payload
   });
   return f;
}

export async function getFullEntry (payload) {
   var f = await axios.get('/api/entry', {
      params: payload
   });
   return f;
}



// WEBPACK FOOTER //
// ./src/backend/site.js